import { createGlobalState } from 'react-hooks-global-state';

const { useGlobalState } = createGlobalState({
    userInfo: {},
    showMenu: false,
    showMenuButton: false,
    score: 0
});

export { useGlobalState }